import { Switch, BrowserRouter as Router } from "react-router-dom";

import { publicRoutes } from "routes/PublicRoute";
import { privateRoutes } from "routes/PrivateRoute";

import NonAuthMiddleware from "routes/NonAuthMiddleware";
import AuthenticatedRedirects from "routes/AuthenticatedRedirects";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchAllStartups } from "redux/startup";

function App() {
  const dispatch = useDispatch();
  const user = useSelector((state) => state?.user?.user);

  useEffect(() => {
    if (user?.id) dispatch(fetchAllStartups());
  }, []);

  return (
    <div>
      <div className="block min-h-screen bg-[#F0F3F4]">
        <Router>
          <Switch>
            {publicRoutes.map((route, idx) => (
              <NonAuthMiddleware
                path={route.path}
                component={route.component}
                key={idx}
              />
            ))}
            {privateRoutes.map((route, idx) => (
              <AuthenticatedRedirects
                path={route.path}
                component={route.component}
                key={idx}
              />
            ))}
          </Switch>
        </Router>
      </div>
    </div>
  );
}

export default App;
